module.exports = __webpack_public_path__ + "img/allianz-turkish-movie-02.d9088036.jpg";